/**
 * useDataAgents Hook
 *
 * React Query hook for fetching data agents list.
 */

import { useQuery } from '@tanstack/react-query';
import { dataAgentService } from '../../../api/data-agent.service';
import type { DataAgent, DataAgentListQuery } from '../../../types/data-agent.types';

export const DATA_AGENTS_QUERY_KEY = 'dataAgents';

export function useDataAgents(tenantId: string, query?: DataAgentListQuery) {
  return useQuery<DataAgent[], Error>({
    queryKey: [DATA_AGENTS_QUERY_KEY, tenantId, query],
    queryFn: () => dataAgentService.listDataAgents(tenantId, query),
    enabled: !!tenantId,
    staleTime: 30000,
  });
}
